// extracted by mini-css-extract-plugin
module.exports = {"heading":"VitrinsHeader_heading__4LcBM"};